import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import { formatFieldValue } from './DynamicForm.form.utils';
import type { RepeatableBlock, RepeatableTemplate } from './DynamicForm.repeatable.utils';
import {
  RepeatableTableWrapper,
  RepeatableTable,
  RepeatableTableHeaderRow,
  RepeatableTableHeaderCell,
  RepeatableTableCell,
  RepeatableTablePencilSlot,
  RepeatableTablePencilButton,
} from './DynamicForm.styles.index';

export type RepeatableFormTableProps = {
  template: RepeatableTemplate;
  blocks: RepeatableBlock[];
  onEdit?: () => void;
};

export function RepeatableFormTable({
  template,
  blocks,
  onEdit,
}: RepeatableFormTableProps): React.JSX.Element {
  const lastColumnIndex = template.baseFields.length - 1;

  return (
    <RepeatableTableWrapper>
      <RepeatableTable>
        <thead>
          <RepeatableTableHeaderRow>
            {template.baseFields.map((field, index) => (
              <RepeatableTableHeaderCell key={field.id}>
                {field.label}
                {onEdit && index === lastColumnIndex && (
                  <RepeatableTablePencilSlot>
                    <RepeatableTablePencilButton type="button" onClick={onEdit} aria-label="Edit">
                      <EditIcon />
                    </RepeatableTablePencilButton>
                  </RepeatableTablePencilSlot>
                )}
              </RepeatableTableHeaderCell>
            ))}
          </RepeatableTableHeaderRow>
        </thead>
        <tbody>
          {blocks.map((block, rowIndex) => (
            <tr key={rowIndex}>
              {template.baseFields.map((field) => (
                <RepeatableTableCell key={field.id}>
                  {formatFieldValue(field, block[field.name])}
                </RepeatableTableCell>
              ))}
            </tr>
          ))}
        </tbody>
      </RepeatableTable>
    </RepeatableTableWrapper>
  );
}
